import { render, staticRenderFns } from "./PanelInputRadio.vue?vue&type=template&id=04cf78ba&scoped=true&"
import script from "./PanelInputRadio.vue?vue&type=script&lang=js&"
export * from "./PanelInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputRadio.vue?vue&type=style&index=0&id=04cf78ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf78ba",
  null
  
)

export default component.exports